import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// React 18 创建根节点
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// 注册 Service Worker（PWA 支持）
// VitePWA 插件会自动处理 SW 注册，这里可以添加额外逻辑
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    console.log('[Talk-o] 应用加载完成，Service Worker 已注册')
  })
}
